import * as types from './mutation-types';

export default {
  [types.SET_PRODUCT_COLLECTION](state, payload) {
    state.productCollection = payload;
  },
  [types.SET_PRODUCT_INVENTORY](state, payload) {
    state.productInventory = payload;
  },
};
